var pageData = window.dataLayer[0];

module.exports = {
    handle: (e, products) => {
        if (!products) {
            return;
        }

        const impressions = JSON.parse(products) || [];
        const currencyCode = impressions && impressions.length ? impressions[0].currencyCode : '';
        const list = pageData.list;

        //Removed productURL, variantId & currencyCode
        const newImpressions = impressions.map(({productURL, variantId, currencyCode,...props}) => ({...props, list}));

        const productsData = {
            event: 'productImpression',
            ecommerce: {
                currencyCode: currencyCode,
                impressions: newImpressions
            },
        };

        if (newImpressions.length > 0) {
            const { customerId, emailAddress } = newImpressions[0];

            customerId ? productsData.userId = customerId : null;
            emailAddress ? productsData.email = emailAddress : null;
        }

        dataLayer.push({ ecommerce: null });
        dataLayer.push(productsData);
    }
}